// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featurelaunch.RentalManagerUserFeatureLaunchWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserFeatureLaunchWebApiHandler_acknowledge,
  RentalManagerUserFeatureLaunchWebApiHandler_notifications,
  RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AcknowledgeFeatureLaunchNotificationsRequestDto,
  FeatureLaunchNotificationsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface NotificationsParams {
  bypassAcknowledged?: boolean;
}

export interface RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Args {
  postData: AcknowledgeFeatureLaunchNotificationsRequestDto;
}

export type RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Args
>;

/**
 * Acknowledge feature launch notifications for a user
 */
export const useRentalManagerUserFeatureLaunchWebApiHandler_acknowledge = (
  options: Omit<RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Args) =>
      RentalManagerUserFeatureLaunchWebApiHandler_acknowledge(args.postData),
  });
};

export type RentalManagerUserFeatureLaunchWebApiHandler_notifications_Options = UseQueryOptions<
  FeatureLaunchNotificationsResponseWebDto,
  unknown,
  FeatureLaunchNotificationsResponseWebDto,
  readonly [string, NotificationsParams]
>;

const RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey = (getParams: NotificationsParams) =>
  [RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path, getParams] as const;

export const RentalManagerUserFeatureLaunchWebApiHandler_notifications_queryOptions = (
  getParams: NotificationsParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey(getParams),
    queryFn: () => RentalManagerUserFeatureLaunchWebApiHandler_notifications(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get list of feature launch notifications for a user
 */
export const useRentalManagerUserFeatureLaunchWebApiHandler_notifications = (
  getParams: NotificationsParams,
  options: Omit<RentalManagerUserFeatureLaunchWebApiHandler_notifications_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerUserFeatureLaunchWebApiHandler_notifications_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserFeatureLaunchWebApiHandler_notifications.getKey =
  RentalManagerUserFeatureLaunchWebApiHandler_notifications_GetKey;
